// import icons from fontawesome
import {
  faSprayCanSparkles,
  faPersonChalkboard,
  faDisplay,
  faWifi,
  faPersonSwimming,
  faBellConcierge,
  faWind,
  faTv,
  faCoffee,
  faBath,
  faPlug,
  faDumbbell,
  faKey,
  faLock,
  faWater,
  faChair,
  faUtensils,
  faUsers,
  faTemperatureLow,
  faLightbulb,
  faWheelchair,
  faChalkboard,
  faMicrophone,
  faBusSimple,
  faUserTie,
} from "@fortawesome/free-solid-svg-icons";

// create an object so the icons be accessed by the name of the amenity, in the hotel page.
const amenitiesIcons = {
  "Complimentary Wi-Fi": faWifi,
  "Pool": faPersonSwimming,
  "Airport Shuttle Included": faBusSimple,
  "Room Service": faBellConcierge,
  "Air Conditioning": faWind,
  "Concierge Service": faUserTie,
  "Flat-screen TV": faTv,
  "Coffee Maker": faCoffee,
  "Premium Bath Amenities": faBath,
  "USB Charging Ports": faPlug,
  "On-site Fitness Center": faDumbbell,
  "Plush Bathrobes and Slippers": faBath,
  "Daily Housekeeping Service": faSprayCanSparkles,
  "Hairdryer": faWind,
  "Daily Housekeeping": faSprayCanSparkles,
  "Work Desk": faDisplay,
  "Electronic Key Card": faKey,
  "In-room Safe": faLock,
  "Bottled Water": faWater,
  "Audio-visual Equipment": faPersonChalkboard,
  "High-speed Wi-Fi": faWifi,
  "Flexible Seating Options": faChair,
  "Catering Services": faUtensils,
  "Event Planning Staff": faUsers,
  "Climate Control": faTemperatureLow,
  "Adjustable Lighting Options": faLightbulb,
  "Accessible Facilities": faWheelchair,
  "Whiteboards or Flip Charts": faChalkboard,
  "Podium or Stage": faMicrophone,
};

export default amenitiesIcons;
